<template>
<div>
  <b-modal size = "lg" ref="modal" id="modal-scrollable" ok-only @hidden="$emit('ok')" :static="false">
    <template slot="modal-title">
      {{title}} <code class="text-nowrap">{{' [' +
        (inspections && sinspection != null && inspections[sinspection] &&
        inspections[sinspection].value.landslide && inspections[sinspection].value.landslide.inspection_date
        ? inspections[sinspection].value.landslide.inspection_date : '-') + ']'}}</code>
    </template>
    <div class="row" v-show = "imageFullscreen == false">
      <div class="col-lg-6">
        <div class="card">
          <div class="card-header no-border">
            <div class="d-flex justify-content-between">
              <h3 class="card-title">IFRM</h3>
            </div>
          </div>
          <div class="card-body">
            <div class="position-relative">
              <!--<canvas id="visitors-chart" height="200"></canvas>-->
              <bar-chart :chart-data="chartdata" :options="chartoptions" :height="200" :plugins="chartplugins"></bar-chart>
            </div>
          </div>
        </div>
        <!-- /.card -->

        <div class="card">
          <div class="card-header no-border">
            <h3 class="card-title">Evaluación Cualitativa</h3>
          </div>
          <div class="card-body p-0">
            <b-table hover striped :items="table" :fields="fields" small>
              <!--<template slot="value" slot-scope="data"> -->
              <template v-slot:cell(value)="data">
                <div class="text-nowrap">
                  {{data.item[4]}}
                  <small :class="'mr-1 ' + (data.item[4] < data.item[5] ?
                    'text-success' : (data.item[4] > data.item[5] ? 'text-danger' : 'text-warning'))">

                    <fa-icon :icon="(data.item[4] < data.item[5] ?
                    'arrow-down' : (data.item[4] > data.item[5] ? 'arrow-up' : 'dot-circle'))" />
                  </small>
                </div>
              </template>
            </b-table>
          </div>
        </div>
        <div class="card" v-if="(inspections && sinspection !== null && inspections[sinspection].value.username)">
          <div class="card-header no-border">
            <h3 class="card-title">Supervisión</h3>
          </div>
          <div class="card-body">
            <div class="d-flex justify-content-between align-items-center border-bottom mb-3" v-if="(inspections && sinspection !== null && inspections[sinspection].value.obs_ot)">
              <p class="d-flex flex-column">
                <span class="font-weight-bold">
                  Observaciones de Oficina Técnica
                </span>
                <span>{{inspections[sinspection].value.obs_ot}}</span>
              </p>
            </div>
            <div class="d-flex justify-content-between align-items-center border-bottom mb-3" v-if="(inspections && sinspection !== null && inspections[sinspection].value.obs_jt)">
              <p class="d-flex flex-column">
                <span class="font-weight-bold">
                  Observaciones de Jefatura
                </span>
                <span>{{inspections[sinspection].value.obs_jt}}</span>
              </p>
            </div>
            <div class="d-flex justify-content-between align-items-center">
              <p class="d-flex flex-column">
                <span class="font-weight-bold">
                  Supervisor CE INMAC
                </span>
                <span>{{inspections[sinspection].value.username}}</span>
              </p>
              <p class="d-flex flex-column" v-if="(inspections[sinspection].value.supervisor_2)">
                <span class="font-weight-bold">
                  Jefe de Obra INMAC
                </span>
                <span>{{inspections[sinspection].value.supervisor_2}}</span>
              </p>
              <p class="d-flex flex-column" v-if="(inspections[sinspection].value.supervisor_3)">
                <span class="font-weight-bold">
                  Supervisión de OT/Gerencia
                </span>
                <span>{{inspections[sinspection].value.supervisor_3}}</span>
              </p>
            </div>
          </div>
        </div>
        <!-- sebas inicio -->
        <!-- <div class="card">
          <div class="card-header no-border">
            <h3 class="card-title">Informes y Documentos Adjuntos del Punto</h3>
          </div>
          <div class="card-body" v-if="fileList.length > 0">
            <li v-for="item in fileList" v-bind:key="item">
                <a href="https://www.google.com" target="_blank">{{item}}</a>
            </li>
                <b-form-file
                v-model="uploadedFile"
                placeholder="Choose a file or drop it here..."
                drop-placeholder="Drop file here..."
                ></b-form-file>
          </div>
          <div v-else class="card-body">
            <p class="d-flex flex-column">
              <span>No hay documentos adjuntos</span>
            </p>
                <b-form-file
                v-model="uploadedFile"
                placeholder="Choose a file or drop it here..."
                drop-placeholder="Drop file here..."
                ></b-form-file>
          </div>
        </div> -->
        <!-- sebas fin -->
        <!-- /.card -->
      </div>
      <!-- /.col-md-6 -->
      <div class="col-lg-6">
        <div ref="parentImagenes">
          <div ref="imagenes" class="card" v-if = "attachments && attachments.length">
            <div class="card-header no-border">
              <div class="d-flex justify-content-between">
                <h3 class="card-title">Imágenes</h3>
              </div>
              <div class="card-tools d-none d-xl-block d-lg-block">
                <a class="btn btn-sm btn-tool" @click="imageFullscreen = !imageFullscreen">
                  <fa-icon :icon="imageFullscreen ? 'compress':'expand'" />
                </a>
              </div>
            </div>
            <div class="card-body">
              <div>
                <b-carousel id="carousel" indicators controls :interval="0">
                  <b-carousel-slide v-for="att in attachments" v-bind:key = "att"
                    :img-src="att"
                  ></b-carousel-slide>
                </b-carousel>
              </div>
            </div>
          </div>
          <!-- /.card -->
        </div>

        <div class="card" v-if="(inspections && sinspection !== null && inspections[sinspection])">
          <div class="card-header no-border">
            <h3 class="card-title">Observaciones</h3>
          </div>
          <div class="card-body">
            <div class="d-flex justify-content-between align-items-center border-bottom mb-3">
              <p class="d-flex flex-column">
                <span class="font-weight-bold">
                  Descripción
                </span>
                <span>{{inspections[sinspection].value.description}}</span>
              </p>
            </div>
            <div class="d-flex justify-content-between align-items-center border-bottom mb-3">
              <p class="d-flex flex-column">
                <span class="font-weight-bold">
                  Medida de Acción
                </span>
                <span>{{inspections[sinspection].value.action_measure}}</span>
              </p>
            </div>
            <router-link class="btn btn-info"
              :to="{ name: $route.params.json + '_view', params: { typex: $route.params.typex, json: $route.params.json, id: inspections[sinspection].value._id } }"
              target="_blank" >
              Mayor detalle
            </router-link>
            <router-link class="btn btn-info"
              :to="{ name: 'form', params: { typex: $route.params.typex, json: $route.params.json, id: inspections[sinspection].value._id } }"
              target="_blank" >
              Modificar Inspección
            </router-link>
          </div>
        </div>
      </div>
      <b-btn @click="imprimir">Imprimir</b-btn>
      <!-- /.col-md-6 -->
    </div>
    <!-- /.row -->
    <div class="row" v-show = "imageFullscreen">
      <div class="col-lg-12" ref="parentFullscreen">
      </div>
    </div>
  </b-modal>
</div>
</template>
<script>
import { mapActions } from 'vuex'
import BarChart from '../chart/BarChart.vue'

export default {
  components: {
    BarChart
  },
  data () {
    return {
      fileList: [],
      uploadedFile: null,
      imageFullscreen: false,
      title: '',
      inspections: [],
      sinspection: null,
      attachments: [],
      table: [],
      fields: [
        {
          key: '0',
          label: 'Variable'
        },
        {
          key: '1',
          label: 'Evaluación'
        },
        {
          key: 'value',
          label: 'Valor'
        }
      ],
      chartdata: {
        labels: [10, 10],
        datasets: [
          {
            label: 'data',
            backgroundColor: '#f87979',
            data: [10, 10]
          }
        ]
      },
      chartoptions: {
        animation: {
          duration: 0
        },
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          display: true,
          labels: {
            filter: function (item, chart) {
              return !item.text.includes('IFRM')
            }
          }
        },
        scales: {
          xAxes: [
            {
              ticks: {
                userCallback: function (label, index, labels) {
                  var date = new Date(label)
                  // return '  ' + months[date.getMonth()] + ' ' + date.getFullYear().toString().substr(-2)
                  return '   ' + (date.getDate() + '-' + (date.getMonth() + 1) + '-' + date.getFullYear().toString().substr(-2)) + '   '
                },
                callback (value, index) {
                  var months = [' ', 'Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Set',
                    'Oct', 'Nov', 'Dic']
                  if (value.length === 9) {
                    return '  ' + months[parseInt(value.toString().substr(0, 2))] + ' ' + value.toString().substr(-4)
                  } else {
                    return ' '
                  }
                }
              },
              type: 'time',
              time: {
                unit: 'month',
                displayFormats: {
                  month: 'MM - YYYY'
                }
              }
            }
          ],
          yAxes: [{
            type: 'linear',
            ticks: {
              beginAtZero: true,
              suggestedMax: 60
              /* callback: function (value, index, values) {
                var nivel = {
                  0: 'Muy Bajo 0',
                  10: 'Bajo 10',
                  20: 'Moderado 20',
                  32: 'Mod. Alto 32',
                  42: 'Alto 42',
                  50: ' 50'
                }
                return nivel[value]
              } */
            },
            afterBuildTicks: function (chartObj) {
              chartObj.ticks = [0, 10, 20, 32, 42, 50]
            }
          }]
        },
        tooltips: {
          callbacks: {
            title: function (tooltipItems, data) {
              var tooltipItem = tooltipItems[0]
              var date = new Date(tooltipItem.xLabel)
              var label = (date.getDate().toString().padStart(2, '0') + '-' +
                (date.getMonth() + 1).toString().padStart(2, '0') + '-' +
                date.getFullYear())
              return label
            },
            label: function (tooltipItem, data) {
              var label = 'IFRM ' + Math.round(tooltipItem.yLabel * 100) / 100
              return label
            }
          }
        },
        onClick: this.chartClick
      },
      chartplugins: [
        {
          id: 'test1',
          beforeDraw: function (chart, easing) {
            /* if (chart.config.options.chartArea && chart.config.options.chartArea.backgroundColor) {
              var ctx = chart.chart.ctx
              var chartArea = chart.chartArea

              ctx.save()
              ctx.fillStyle = chart.config.options.chartArea.backgroundColor
              console.log(chartArea)
              ctx.fillRect(chartArea.left, chartArea.top, chartArea.right - chartArea.left, chartArea.bottom - chartArea.top)
              ctx.restore()
            } */
            // console.log(chart.getDatasetMeta(0))
            var ctx = chart.ctx
            var chartArea = chart.chartArea
            var prevy = chartArea.bottom
            ctx.save()
            for (var i = 1; i < 6; i++) {
              var datax = chart.getDatasetMeta(i).data
              // console.log(model)
              ctx.fillStyle = datax[0]._model.backgroundColor
              ctx.fillRect(datax[0]._model.x, datax[0]._model.y, datax[1]._model.x - datax[0]._model.x, prevy - datax[0]._model.y)
              prevy = datax[0]._model.y
            }
            ctx.restore()
          }
        }
      ],
      metadata: null,
      ticks: [
        { y: 10, r: 0, g: 176, b: 80, nombre: 'Muy Bajo' },
        { y: 20, r: 146, g: 208, b: 80, nombre: 'Bajo' },
        { y: 32, r: 255, g: 255, b: 0, nombre: 'Moderado' },
        { y: 42, r: 255, g: 192, b: 0, nombre: 'Moderadamente Alto' },
        { y: 50, r: 255, g: 0, b: 0, nombre: 'Alto' }
      ]
    }
  },
  props: {
    inspection: Object
  },
  watch: {
    inspection (to, from) {
      // console.log('watch inspección', to, from)
      this.loadInspections()
      // this.getFiles()
    },
    sinspection (to, from) {
      if (to !== null) {
        var obj = this
        this.loadPlot()
        this.loadTable()
        this.loadAttachments()
        var insp = obj.inspections[obj.sinspection].value
        if (insp.identification) {
          if (insp.identification.type && insp.identification.type === 'plataforma') {
            var titulo = ''
            var parcial = ''
            for (var i in obj.metadata.identification.choices[1].children.platform.choices) {
              parcial = obj.metadata.identification.choices[1].children.platform.choices[i]
              if (insp.identification.platform === parcial.value) {
                titulo = titulo + parcial.display_name
              }
            }
            for (i in obj.metadata.identification.choices[1].children.instalation.choices) {
              parcial = obj.metadata.identification.choices[1].children.instalation.choices[i]
              if (insp.identification.instalation === parcial.value) {
                titulo = titulo + ' - ' + parcial.display_name
              }
            }
            for (i in obj.metadata.identification.choices[1].children.talud.choices) {
              parcial = obj.metadata.identification.choices[1].children.talud.choices[i]
              if (insp.identification.talud === parcial.value) {
                titulo = titulo + ' - ' + parcial.display_name
              }
            }
            obj.title = titulo
          } else {
            for (i in obj.metadata.identification.choices[0].children.flowline.choices) {
              var j = obj.metadata.identification.choices[0].children.flowline.choices[i]
              if (j.value === insp.identification.flowline) {
                if (parseInt(insp.identification.progressive % 1000) > 99) {
                  if (parseInt(insp.identification.progressive / 1000) > 9) {
                    obj.title = j.display_name + ' PK' +
                    parseInt(insp.identification.progressive / 1000) + '+' + parseInt(insp.identification.progressive % 1000)
                  } else {
                    obj.title = j.display_name + ' PK' +
                    '0' + parseInt(insp.identification.progressive / 1000) + '+' + parseInt(insp.identification.progressive % 1000)
                  }
                } else if (parseInt(insp.identification.progressive % 1000) > 9) {
                  if (parseInt(insp.identification.progressive / 1000) > 9) {
                    obj.title = j.display_name + ' PK' +
                    parseInt(insp.identification.progressive / 1000) + '+0' + parseInt(insp.identification.progressive % 1000)
                  } else {
                    obj.title = j.display_name + ' PK' +
                    '0' + parseInt(insp.identification.progressive / 1000) + '+0' + parseInt(insp.identification.progressive % 1000)
                  }
                } else {
                  if (parseInt(insp.identification.progressive / 1000) > 9) {
                    obj.title = j.display_name + ' PK' +
                    parseInt(insp.identification.progressive / 1000) + '+00' + parseInt(insp.identification.progressive % 1000)
                  } else {
                    obj.title = j.display_name + ' PK' +
                    '0' + parseInt(insp.identification.progressive / 1000) + '+00' + parseInt(insp.identification.progressive % 1000)
                  }
                }
              }
            }
          }
        }
      }
    },
    imageFullscreen (to, from) {
      if (to) {
        this.$refs.parentFullscreen.appendChild(this.$refs.imagenes)
      } else {
        this.$refs.parentImagenes.appendChild(this.$refs.imagenes)
      }
    }
  },
  mounted () {
    var obj = this
    import('../../configuration/json/inspection.json').then(function (met) {
      obj.metadata = met
      this.loadInspections()
    })
  },
  methods: {
    ...mapActions([
      'get_db'
    ]),
    getFiles () {
      if (this.inspection) {
        const url = 'http://localhost:8000/files/'
        let body = {
          'flowline': this.inspection.identification.flowline,
          'progressive': this.inspection.identification.progressive
        }
        this.$http.post(url, body).then(response => {
          console.log('API reponse', response)
          this.fileList = response.body.doc_list
          console.log('this.fileList', this.fileList)
        })
      }
    },
    loadInspections () {
      let obj = this
      if (this.inspection) {
        obj.get_db().then(function (db) {
          var query = {}
          if (obj.inspection.identification.type && obj.inspection.identification.type === 'plataforma') {
            query = {
              startkey: [obj.inspection.identification.platform, obj.inspection.identification.instalation,
                obj.inspection.identification.talud],
              endkey: [obj.inspection.identification.platform, obj.inspection.identification.instalation,
                obj.inspection.identification.talud, {}],
              descending: false
            }
          } else {
            query = {
              startkey: [obj.inspection.identification.flowline, obj.inspection.identification.progressive,
                obj.inspection.identification.side_to_ddv],
              endkey: [obj.inspection.identification.flowline, obj.inspection.identification.progressive,
                obj.inspection.identification.side_to_ddv, {}],
              descending: false
            }
          }
          db.query('app/checklist', query).then(function (res) {
            obj.$set(obj, 'inspections', res.rows)
            for (var i in res.rows) {
              if (res.rows[i].value._id === obj.inspection._id) {
                obj.$set(obj, 'sinspection', parseInt(i))
              }
            }
            /* obj.loadPlot()
            obj.loadTable() */
          })
        })
        obj.$refs['modal'].show()
      } else {
        obj.title = ''
        obj.inspections = []
        obj.sinspection = null
        obj.attachments = []
        obj.table = []
        obj.imageFullscreen = false
      }
    },
    loadTable () {
      var obj = this
      obj.$set(obj, 'table', [])
      for (var i in obj.inspections[obj.sinspection].value.ifrm.ifrm_table) {
        var item = obj.inspections[obj.sinspection].value.ifrm.ifrm_table[i]
        if (obj.sinspection > 0) {
          item.push(obj.inspections[obj.sinspection - 1].value.ifrm.ifrm_table[i][4])
        } else {
          item.push(item[4])
        }
        obj.table.push(item)
      }
    },
    loadPlot () {
      var obj = this
      var data = []
      var colors = []
      var borders = []
      var pointborders = []
      for (var i in obj.inspections) {
        var insp = obj.inspections[i].value
        var elem = {
          x: new Date(insp.landslide && insp.landslide.inspection_date ? insp.landslide.inspection_date : '2000-01-01'),
          y: (insp.ifrm && insp.ifrm.ifrm_value ? (parseFloat(insp.ifrm.ifrm_value) || 0) : 0)
        }
        elem.x = new Date(elem.x.getTime() + elem.x.getTimezoneOffset() * 60000)
        data.push(elem)
        var ifrm = data[data.length - 1].y
        var color = null
        if (ifrm <= 10) {
          color = 'rgb(0,176,80)'
        } else if (ifrm <= 20) {
          color = 'rgb(146,208,80)'
        } else if (ifrm <= 32) {
          color = 'rgb(255,255,0)'
        } else if (ifrm <= 42) {
          color = 'rgb(255,192,0)'
        } else {
          color = 'rgb(255,0,0)'
        }
        colors.push(color)
        if (parseInt(i) === obj.sinspection) {
          borders.push('black')
          pointborders.push(4)
        } else {
          borders.push('rgb(120,120,120)')
          pointborders.push(2)
        }
      }
      var d1 = data[0].x
      var d2 = data[data.length - 1].x
      if (d1 === d2) { d2 = new Date(d1.valueOf() + 1 * 24 * 60 * 60) }
      var ticks = []
      for (i in obj.ticks) {
        ticks[i] = {
          type: 'line',
          label: obj.ticks[i].nombre,
          data: [
            { x: 1.05 * d1 - 0.05 * d2, y: obj.ticks[i].y },
            { x: 1.05 * d2 - 0.05 * d1, y: obj.ticks[i].y }
          ],
          backgroundColor: 'rgba(' + obj.ticks[i].r + ',' + obj.ticks[i].g + ',' + obj.ticks[i].b + ',0.25)',
          borderColor: 'rgb(' + obj.ticks[i].r + ',' + obj.ticks[i].g + ',' + obj.ticks[i].b + ')',
          borderWidth: 1,
          fill: false
        }
      }
      this.$set(this, 'chartdata', {
        datasets: [
          {
            type: 'scatter',
            label: 'IFRM',
            fill: false,
            showLine: true,
            pointRadius: 8,
            pointHoverRadius: 10,
            pointBackgroundColor: colors,
            // pointBackgroundColor: 'rgb(150,150,255)',
            pointBorderColor: borders,
            borderWidth: 2,
            pointBorderWidth: pointborders,
            borderColor: 'rgb(120,120,120)',
            data: data
          },
          ...ticks
        ]
      })
    },
    loadAttachments () {
      var obj = this
      obj.attachments = []
      // var p = Promise.resolve(0)
      if (obj.inspections && obj.sinspection !== null && obj.inspections[obj.sinspection]) {
        obj.get_db().then(async function (db) {
          var indexes = []
          for (var i in (obj.inspections[obj.sinspection].value.image || {})) {
            indexes.push(i)
          }
          for (i in (obj.inspections[obj.sinspection].value.esquema || {})) {
            indexes.push(i)
          }
          /* for (i in indexes) {
            p = p.then(function (i) {
              return db.getAttachment(obj.inspections[obj.sinspection].value._id, i, { attachments: true, binary: true })
                .then(function (img) {
                  obj.attachments.push(window.URL.createObjectURL(img))
                }).catch(function (err) {
                  console.log(err)
                })
            }(indexes[i]))
          } */
          for (i in indexes) {
            await db.getAttachment(obj.inspections[obj.sinspection].value._id, indexes[i], { attachments: true, binary: true })
              .then(function (img) {
                obj.attachments.push(window.URL.createObjectURL(img))
              }).catch(function (err) {
                console.log(err)
              })
          }
        })
      }
    },
    chartClick (event, array) {
      if (array && array.length) {
        this.$set(this, 'sinspection', parseInt(array[0]._index))
        /* this.loadPlot()
        this.loadTable() */
      }
    },
    imprimir () {
      var obj = this
      console.log(this.inspection)
      let routeData = this.$router.resolve({
        name: 'holdpoint',
        params: {
          typex: obj.$route.params.typex,
          json: obj.$route.params.json,
          id: this.inspection._id
        }
      })
      window.open(routeData.href, '_blank')
    }
  }
}
</script>
<style>
@media (min-width: 768px) {
  .modal-lg {
    width: 90% !important;
   max-width:1200px !important;
  }
}
#sidebar-overlay {
  z-index: 1037 !important;
}
.main-sidebar {
  z-index: 1038 !important;
}
.leaflet-pseudo-fullscreen {
  z-index: 1039 !important;
}
</style>
